import * as React from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import TacticsChart from "security-app/components/common/ThreatCoverageWidget/TacticsChart";
import TacticsList from "security-app/components/common/ThreatCoverageWidget/TacticsList";
import { Timestamp } from "components/common";
import useUserDateTime from "hooks/useUserDateTime";
import usePermissions from "hooks/usePermissions";
import { Alert } from "components/bootstrap";
import permissions from "security-app/Permissions";
export const RENDER_TYPE = "threat_coverage";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const ThreatCoverageExportPage = ({ data }) => {
  const { userTimezone } = useUserDateTime();
  const { isPermitted } = usePermissions();
  const { t } = useTranslation("enterprise_search");
  if (!isPermitted(permissions.securityApp.read)) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, t("threat_coverage_export_page.not_permitted"));
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h1", { className: "has-bm" }, t("threat_coverage_export_page.title")), /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(TacticsChart, { tactics: data.data.elements }), /* @__PURE__ */ React.createElement(TacticsList, { tactics: data.data.elements }), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "threat_coverage_export_page.created_at",
      values: { userTimezone },
      components: { timestamp: /* @__PURE__ */ React.createElement(Timestamp, { dateTime: /* @__PURE__ */ new Date() }) }
    }
  ))));
};
export default ThreatCoverageExportPage;
